import { Habitat } from '@akin-home/amplify';
import { v4 as uuid } from 'uuid';
import { HabitatModel } from '../types';

/**
 * Creates a habitat model
 */
export const createHabitatModel = (
  input: Partial<HabitatModel> & { habitatID: string }
): HabitatModel => ({
  id: uuid(),
  favouriteRecipesM2m: [],
  favouriteRecipes: [],
  favouriteRecipeIDs: [],
  ...input,
});

export const sortHabitatsAlphabetically = (habitats: Habitat[] | HabitatModel[]) =>
  habitats.sort((a: any, b: any) => {
    if (a.habitatID < b.habitatID) {
      return -1;
    }
    if (a.habitatID > b.habitatID) {
      return 1;
    }
    return 0;
  });

export const addFavouriteRecipeToHabitat = (
  habitat: HabitatModel,
  recipeID: string
): HabitatModel => ({
  ...habitat,
  favouriteRecipeIDs: !habitat.favouriteRecipeIDs.includes(recipeID)
    ? [...habitat.favouriteRecipeIDs, recipeID]
    : habitat.favouriteRecipeIDs,
});

export const removeFavouriteRecipeFromHabitat = (
  habitat: HabitatModel,
  recipeID: string
): HabitatModel => ({
  ...habitat,
  favouriteRecipeIDs: habitat.favouriteRecipeIDs.filter(
    (id) => id !== recipeID
  ),
});
